export default function createContactsFiltersTrackingService(
    track: (category: string, action: string, event: string) => void,
) {
    function trackWithDefaultCategory(action: string, event: string) {
        track("lead gen filters", action, event);
    }

    function trackEmployeeProfilesAction(action: string, event: string) {
        trackWithDefaultCategory(action, `profiles/${event}`);
    }

    function trackWithDefaultCategoryProfileEvent(action: string, event: string) {
        track("lead gen filters", action, `profiles/${event}`);
    }

    return {
        trackProfilesEmptyStateDismissed() {
            trackEmployeeProfilesAction("dismiss empty state", "");
        },
        trackProfileCollapsed(name: string) {
            trackEmployeeProfilesAction("collapse profile", name);
        },
        trackProfileExpanded(name: string) {
            trackEmployeeProfilesAction("expand profile", name);
        },
        trackProfileEnabled(name: string) {
            trackEmployeeProfilesAction("activate profile", `activate/${name}`);
        },
        trackProfileDisabled(name: string) {
            trackEmployeeProfilesAction("deactivate profile", `deactivate/${name}`);
        },
        trackProfileRenamed(oldName: string, newName: string) {
            trackEmployeeProfilesAction("rename profile", `${oldName}/${newName}`);
        },
        trackProfileDeleted(name: string) {
            trackEmployeeProfilesAction("delete profile", `delete/${name}`);
        },
        trackProfileDepartmentAdded(department: string) {
            trackWithDefaultCategoryProfileEvent("select departments", `add departments/${department}`);
        },
        trackProfileDepartmentRemoved(department: string) {
            trackWithDefaultCategoryProfileEvent("reset department", `remove departments/${department}`);
        },
        trackProfileSeniorityAdded(seniority: string) {
            trackWithDefaultCategoryProfileEvent("select seniority", `add seniority/${seniority}`);
        },
        trackProfileSeniorityRemoved(seniority: string) {
            trackWithDefaultCategoryProfileEvent("reset seniority", `remove seniority/${seniority}`);
        },
        trackProfileTitleAddedToInclude(title: string) {
            trackEmployeeProfilesAction("include title", `add title/${title}`);
        },
        trackProfileTitleRemovedFromInclude(title: string) {
            trackEmployeeProfilesAction("include title", `cancel title/${title}`);
        },
        trackProfileTitleAddedToExclude(title: string) {
            trackEmployeeProfilesAction("exclude title", `add title/${title}`);
        },
        trackProfileTitleRemovedFromExclude(title: string) {
            trackEmployeeProfilesAction("exclude title", `cancel title/${title}`);
        },
        trackAddProfileClicked(numberOfProfiles: number) {
            trackEmployeeProfilesAction("add profile", `${numberOfProfiles}/`);
        },
    };
}
